<template>
	<ValidationObserver tag="form" ref="observer" @submit.prevent="handleSubmit()">
	    <p class="f-14 f-m-12 margin-0"><strong>Info Driver</strong></p>
	    <div class="row">
	        <div class="col">
				<div class="form-group mb-0">
					<label class="form-label">Nama</label>
					<ValidationProvider name="Nama" rules="required" v-slot="{ errors }">
						<input type="text" v-model="model.name" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan nama">
						<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
					</ValidationProvider>
				</div>
				<div class="form-group">
					<label class="form-label">Nomor telepon</label>
					<ValidationProvider name="Nomor telepon" rules="required|numeric" v-slot="{ errors }">
						<input type="text" v-model="model.phone_number" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan nomor telepon">
						<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
					</ValidationProvider>
				</div>
				<div class="form-group mb-0">
					<label class="form-label">Tipe Driver</label>
				</div>
				<ValidationProvider name="Driver" rules="required" v-slot="{ errors }">
					<div class="form-group mb-0">
						<div class="form-check form-check-inline">
							<input type="checkbox" id="is_driver" class="form-check-input" :class="{ 'is-invalid': errors[0] }" v-model="model.driver_assistants" value="is_driver"/>
							<label class="form-label mb-0" for="is_driver">Driver</label>						
						</div>
						<div class="form-check form-check-inline">
							<input type="checkbox" id="is_assistant" class="form-check-input" :class="{ 'is-invalid': errors[0] }" v-model="model.driver_assistants" value="is_assistant" />
							<label class="form-label mb-0" for="is_assistant">Assisten Driver</label>
						</div>
					</div>
					<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
				</ValidationProvider>
	        </div>
	        <div class="col">
				<div class="form-group mb-0">
					<label class="form-label">Nomor SIM</label>
						<ValidationProvider name="Nomor SIM" rules="required|numeric" v-slot="{ errors }">
							<input type="text" v-model="model.sim" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan nomor SIM">
							<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
						</ValidationProvider>
					</div>
				<div class="form-group">
					<label class="form-label">Nomor telepon lain yang bisa dihubungi saat keadaan darurat</label>
					<ValidationProvider name="Nomor darurat" rules="required|numeric" v-slot="{ errors }">
						<input type="text" v-model="model.emergency_number" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan nomor telepon lain yang bisa dihubungi saat keadaan darurat">
						<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
					</ValidationProvider>
				</div>
	        </div>  
	    </div>
	    <p class="f-14 f-m-12 margin-0"><strong>Device</strong></p>
	    <div class="row">
	        <div class="form-group col ml-0">
	            <label class="form-label">Device</label>
				<ValidationProvider name="model.id_device">
	            	<SelectOption keyId="id_device" :defaultId="model.id_device" @setValue="setValueIdDevice"/>
	        	</ValidationProvider>
	        </div>                   
	        <div class="form-group col mr-0">
	            <label class="form-label">Nomor telepon device</label>
	            <input type="text" v-model="nomor_device" class="form-control" readonly>
	        </div>  
	    </div>    
	    <hr>
	    
	    <button type="submit" class="float-right btn btn-primary col-2 mb-3 w-m-1-2 margin-5 pd-10-20">Simpan</button>
	</ValidationObserver>
</template>

<script>
import SelectOption from './SelectOption'
export default {
	name: 'Form',
	components: {
		SelectOption
	},
	data() {
		return {
			model: {
				name: null,
				phone_number: null,
				emergency_number: null,
				sim: null,
				id_device: null,
				driver_assistants: [],
				is_driver: false,
				is_assistant: false,
			},
			nomor_device: null,
			suggestDevice: [
				{
				    data: []
				}
			]
		}
	},
	beforeMount() {
		let _ = this

		if ( _.$route.params.id ) {
			_.getData()
		}
	},
	methods: {
		create() {
			let _ = this
			let data = _.model
			data.is_assistant = data.driver_assistants.includes('is_assistant');
			data.is_driver = data.driver_assistants.includes('is_driver');
			_.axios.post('driver', data )
				.then(resp => {
					if ( resp.data.status ) {
						_.$router.push({
							name: 'DriverIndex',
							params: {
								status: 'insert'
							}
						})
					}
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		update() {
			let _ = this
			let update = {
				id: _.$route.params.id,
				..._.model
			}
			update.is_assistant = update.driver_assistants.includes('is_assistant');
			update.is_driver = update.driver_assistants.includes('is_driver');

			_.axios.patch('/driver', update)
				.then(resp => {
					if ( resp.data.status ) {
						_.$router.push({
							name: 'DriverIndex',
							params: {
								status: 'update'
							}
						})
					}
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		getData() {
			let _ = this
			_.axios.get('/driver?id=' + _.$route.params.id)
				.then(resp => {
					let getData = resp.data.data.rows
					_.model = {
						name: getData.name,
						phone_number: getData.phone_number,
						emergency_number: getData.emergency_number,
						sim: getData.sim,
						is_assistant: getData.is_assistant,
						is_driver: getData.is_driver,
						id_device: getData.id_device,
						driver_assistants: []						
					}	
					if (getData.id_device != null) {
						_.model.id_device = getData.device.id
						_.nomor_device = getData.device.phone_number
					}	
					if (_.model.is_driver) {
						_.model.driver_assistants.push('is_driver');
					}
					if (_.model.is_assistant) {
						_.model.driver_assistants.push('is_assistant');
					}	
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		setValueIdDevice(val) {
			let _ = this
			_.model.id_device = val.id
			_.nomor_device = val.phone_number
		},
        formattedDisplay(result) {
		    return result.item.merk
		},
		selectedDeviceReceive(result) {
		    let _ 							= this
			let item 						= result.item
			_.model.id_device				= item.id
			_.nomor_device					= item.phone_number
		},
		searchNamaDevice(input) {
		    let _ = this
			_.axios.get('/device?status=1&key=' + input).then(resp => {
                _.suggestDevice[0].data = resp.data.data.rows.data
            }).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
		},
		async handleSubmit(){
			let _ = this
			const isValid = await this.$refs.observer.validate()
			if (isValid) {
				if (_.$route.params.id){
					_.update()
				} else {
					_.create()
				}
			}
		}
	}
}
</script>